import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { BrandModel } from '../shared/brand.model';
import { FilterItemsService } from '../shared/filter-items.service';
import { BrandLogo } from '../brand-logos/brand-logo.model';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrandLogosService } from '../brand-logos/brand-logos.service';
import { BrandPreidService } from './brand-preid.service';
import { AdModel } from './ad-model.model';
import { setTimeout } from 'core-js/library/web/timers';
import { PageSizeSelectionComponent } from '../shared/page-size-selection.component';
import { DropdownValue } from '../shared/dropdown.model';
import { CustomHorizontalScrollService } from '../shared/custom-horizontal-scroll.service';
import { BrandStatistics, AdTrailerStatusEnum } from '../brand-statistics/brand-statistics.model';
import { BrandStatisticsService } from '../brand-statistics/brand-statistics.service';
import { SortModel } from '../shared/sort.model';
import { ClaimsService } from '../core/services';
import { BrandStatisticsSortField } from '../brand-statistics/brand-statistics-sort.enum';
import { SortService } from '../shared/sort.service';
import { NotificationService } from "../core/services";

@Component({
  moduleId: module.id,
  templateUrl: 'brand-preid.component.html'
})
export class BrandPreidComponent implements OnInit, AfterViewInit, OnDestroy {
  showTopOverlay: boolean = true;
  showBottomOverlay: boolean = true;
  showAdminActionButtons: boolean = false;
  useLightClass: boolean = true;

  selectedBrand: any;
  adTitle: any;
  adDescription: any;
  brandsList: Array<BrandModel> = [];
  brandId?: number;
  brandLogosList: Array<BrandLogo> = [];
  brandLogoAssociationId?: number;
  showBrandOverlay: boolean = false;
  public mediaFileFilter: string = '';
  public brandNameFilter: string = '';

  data: Array<BrandStatistics> = [];
  isIdentified: boolean = false;
  videoPlayerSource: string;
  mediaFileCount: number = 0;

  adTrailer: string = '';
  adTrailerStatus: number = AdTrailerStatusEnum.None;
  showAdTrailerOverlay: boolean = false;

  private inXhrGetBrandStatistics: any;

  private sortField: SortModel;
  private sortAsc: boolean;
  pageNumber: number = 1;
  totalCount: number;
  pageSize: number = 0;
  brandSort: SortModel = new SortModel(BrandStatisticsSortField.BrandName, SortModel.ascIcon);
  requestCountSort: SortModel = new SortModel(BrandStatisticsSortField.RequestCount, SortModel.disabledIcon);
  mediaFileSort: SortModel = new SortModel(BrandStatisticsSortField.MediaFile, SortModel.disabledIcon);
  associatedToBrandSort: SortModel = new SortModel(BrandStatisticsSortField.AssociatedToBrand, SortModel.disabledIcon);
  createdUnsignedAdSort: SortModel = new SortModel(BrandStatisticsSortField.CreatedUnidentifiedAd, SortModel.disabledIcon);

  @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent

  constructor(private filterItemsService: FilterItemsService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private claimsService: ClaimsService,
    private brandStatsService: BrandStatisticsService,
    private brandLogosService: BrandLogosService,
    private brandPreIdService: BrandPreidService,
    private scrollService: CustomHorizontalScrollService,
    private sortService: SortService,
    private notification: NotificationService) { }

  ngOnInit() {
    this.showAdminActionButtons = this.claimsService.getUserTypeId() === 1;
    this.sortField = this.brandSort;
    this.sortAsc = true;
    this.brandsList = this.filterItemsService.getBrands();
  }

  public getBrandStatisticsAndInfo(page: number): void {
    this.showTopOverlay = true;
    this.showBottomOverlay = true;
    if (this.inXhrGetBrandStatistics) {
      this.inXhrGetBrandStatistics.unsubscribe();
    }
    this.inXhrGetBrandStatistics = this.brandStatsService.getBrandStatistics(this.sortField.fieldId, this.sortAsc, page, this.pageSize,
      this.brandNameFilter, this.mediaFileFilter)
      .subscribe((result: any) => {
        this.totalCount = result.json().total;
        this.pageNumber = page;
        this.data = <Array<BrandStatistics>>result.json().data;
      },
        () => {
          this.showTopOverlay = false;
          this.showBottomOverlay = false;
        },
        () => {
          if (this.data.length > 0) {
            //set the first media file in the player
            this.videoPlayerSource = this.data[0].mediaFile;
            this.adTrailer = this.data[0].adTrailerUrl;
            this.adTrailerStatus = this.data[0].adTrailerStatus;
            //set the brand info if any
            this.populateBrandInfoSection(this.data[0].brandName, this.data[0].logoUrl, this.data[0].title, this.data[0].description);
          }
          else {
            this.videoPlayerSource = '';
            this.adTrailer = '';
            this.adTrailerStatus = AdTrailerStatusEnum.None;
            this.clearBrandInfoSection();
          }
          this.toggleHorizontalScroll();
          this.showTopOverlay = false;
          this.showBottomOverlay = false;
        });
  }
  onFilter(event) {
    this.getBrandStatisticsAndInfo(1);
  }

  onResetFilters(event) {
    this.mediaFileFilter = '';
    this.brandNameFilter = '';
    this.clearBrandInfoSection();
    this.getBrandStatisticsAndInfo(1);
  }

  onResize(event) {
    this.toggleHorizontalScroll();
  }

  onPageSizeChanged(item: DropdownValue) {
    this.showTopOverlay = true;
    this.showBottomOverlay = true;
    this.pageSize = item.value;
    this.pageNumber = 1;
    this.getBrandStatisticsAndInfo(this.pageNumber);
  }

  private toggleHorizontalScroll() {
    let self = this;
    setTimeout(function () {
      self.scrollService.toggleHorizontalScroll();
    }, 5);
  }

  onSaveBrandInfo() {
    this.showTopOverlay = true;
    this.showBottomOverlay = true;
    //set brand for identified ad
    let brandLogo = this.brandLogosList.find(x => x.id == this.brandLogoAssociationId);
    let self = this;
    this.brandPreIdService.setIdentifiedAd(this.videoPlayerSource, this.brandId, brandLogo.logoUrl, brandLogo.height, brandLogo.width,
      this.adTitle, this.adDescription)
      .subscribe(response => { },
        () => { },
        () => { self.onRefreshMediaFiles(); });
  }

  onNextMediaFile() {
    this.showTopOverlay = true;
    this.isIdentified = false;
    this.mediaFileCount++;
    if (this.mediaFileCount >= this.data.length) this.mediaFileCount = 0;
    this.onMediaFileSelectionChange();
  }

  onPrevMediaFile() {
    this.showTopOverlay = true;
    this.isIdentified = false;
    this.mediaFileCount--;
    if (this.mediaFileCount < 0) this.mediaFileCount = this.data.length - 1;
    this.onMediaFileSelectionChange();
  }

  private onMediaFileSelectionChange() {
    this.videoPlayerSource = this.data[this.mediaFileCount].mediaFile;
    this.adTrailer = this.data[this.mediaFileCount].adTrailerUrl;
    this.adTrailerStatus = this.data[this.mediaFileCount].adTrailerStatus;
    this.clearBrandInfoSection();
    //if selection contains brand info, pre-set the data in the brand info section
    this.populateBrandInfoSection(this.data[this.mediaFileCount].brandName, this.data[this.mediaFileCount].logoUrl,
      this.data[this.mediaFileCount].title, this.data[this.mediaFileCount].description);
    this.showTopOverlay = false;
  }

  //no longer used
  // private scrollToSelectedVideo() {
  //   setTimeout(() => {
  //     let allMp4 = $(this.el.nativeElement.querySelectorAll("#mediaFilesTable")).find('tr');
  //     $(allMp4).each(function (i, e) {
  //       $(e).removeAttr('id');
  //     });
  //     let selectedMp4 = $(this.el.nativeElement.querySelectorAll("#mediaFilesTable")).find('tr.selected-video');
  //     $(selectedMp4).attr('id', 'is-Selected');
  //     let x = document.getElementById('is-Selected');
  //     x.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  //   }, 10);
  // }

  onSelectedMediaFile(item, index) {
    this.showTopOverlay = true;
    //clear selected brand
    this.clearBrandInfoSection();
    //if selection contains brand info, pre-set the data in the brand info section
    this.populateBrandInfoSection(item.brandName, item.logoUrl, item.title, item.description);
    //set the selected video in player
    this.videoPlayerSource = item.mediaFile;
    this.adTrailer = item.adTrailerUrl;
    this.adTrailerStatus = item.adTrailerStatus;
    this.mediaFileCount = index;
    this.showTopOverlay = false;
  }

  onBrandAutocompleteClicked(item) {
    let ng2Autocomplete = this.el.nativeElement.querySelectorAll("ng2-auto-complete");
    $(ng2Autocomplete).addClass('custom-autocomplete');
    //remove the selection from the previous brand and select the current brand
    let listOfBrands = $(ng2Autocomplete).find('ul li');
    let brand = this.selectedBrand;
    $(listOfBrands).each(function (i, e) {
      $(e).removeClass('selected');
      if (brand == $(e).text()) $(e).addClass('selected');
    });
  }

  private clearBrandInfoSection() {
    this.selectedBrand = null;
    this.adTitle = null;
    this.adDescription = null;
    this.brandId = 0;
    this.brandLogosList = [];
    this.brandLogoAssociationId = null;
    this.isIdentified = false;
  }

  private populateBrandInfoSection(brandName: any, logoUrl: any, title: any, description: any) {
    if (brandName) {
      this.showBrandOverlay = true;
      this.adTitle = title;
      this.adDescription = description;
      this.selectedBrand = brandName;
      this.brandId = this.brandsList.find(x => x.name == brandName).id;
      this.brandLogosService.getBrandLogosForBrand(this.brandId).subscribe(response => {
        let list = response.json();
        this.brandLogosList = [];
        if (list) {
          for (let item of list) {
            this.brandLogosList.push(item);
          }
          if (logoUrl) {
            let associatedLogo = this.brandLogosList.find(x => x.logoUrl == logoUrl);
            this.brandLogoAssociationId = associatedLogo.id;
            this.isIdentified = true;
          }
        }
      }, () => { }, () => {
        let self = this;
        setTimeout(function () {
          self.showBrandOverlay = false;
        }, 200);
      });
    }
  }

  onRefreshMediaFiles() {
    this.showTopOverlay = true;
    this.showBottomOverlay = true;
    this.data = [];
    this.mediaFileCount = 0;
    this.brandsList = this.filterItemsService.getBrands();
    this.clearBrandInfoSection();
    this.getBrandStatisticsAndInfo(1);
  }

  onBrandValueInTableFilterChanged(item) {
    this.showTopOverlay = true;
    this.showBottomOverlay = true;
    this.brandNameFilter = item.name;
    this.getBrandStatisticsAndInfo(1);
  }

  onBrandValueChanged(item) {
    this.showBrandOverlay = true;
    this.brandId = item.id;
    this.populateBrandLogosForBrandInfoSection();
  }

  private populateBrandLogosForBrandInfoSection() {
    this.brandLogosService.getBrandLogosForBrand(this.brandId).subscribe(response => {
      let list = response.json();
      this.brandLogosList = [];
      if (list) {
        for (let item of list) {
          this.brandLogosList.push(item);
        }
      }
    }, () => { }, () => {
      let self = this;
      setTimeout(function () {
        self.showBrandOverlay = false;
      }, 200);
    });
  }

  onBrandLogoSelection(item) {
    this.brandLogoAssociationId = item.id;
    this.isIdentified = true;
  }

  autocompleListFormatter(data: any): string {
    return `${data.name}`;
  }

  removeBrandToAdAssociation(event, brandMediaFile: string) {
    if (confirm('Are you sure you want to remove the association between ad and brand?')) {
      event.preventDefault();
      event.stopPropagation();
      this.clearBrandInfoSection();
      this.brandStatsService.removeBrandToAdAssociation(brandMediaFile)
        .subscribe(() => this.getBrandStatisticsAndInfo(this.pageNumber))
    }
  }

  onGenerateAdTrailerClick(event) {
    this.showAdTrailerOverlay = true;
    this.brandStatsService.requestNewAdTrailerForMediaFile(this.data[this.mediaFileCount].mediaFile)
      .subscribe(response => { this.data[this.mediaFileCount].adTrailerStatus = AdTrailerStatusEnum.Pending; this.adTrailerStatus = AdTrailerStatusEnum.Pending; },
        () => { }, () => { this.showAdTrailerOverlay = false; });
  }

  onSortChanged(sort: SortModel) {
    let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortAsc, sort);
    this.sortField = sortResult.existingSortModel;
    sort = sortResult.selectedSortModel;
    this.sortAsc = sortResult.sortDiresctionAsc;

    this.getBrandStatisticsAndInfo(1);
  }

  ngAfterViewInit() {
    this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
    this.getBrandStatisticsAndInfo(1);

    let self = this;
    setTimeout(function (this) {
      let advertising = $("#adBanner");
      if (advertising.css("display") == 'none')
        self.notification.showWarning("An Ad Blocker is enabled. Please disable it and reload the page in order to see the content.");
    }, 1000);
  }

  ngOnDestroy() {
    if (this.inXhrGetBrandStatistics) {
      this.inXhrGetBrandStatistics.unsubscribe();
    }
    this.scrollService.toggleHorizontalScroll(false);
  }
}


// WEBPACK FOOTER //
// ./src/app/brand-preid/brand-preid.component.ts